import { CurrencyEnum, LocaleEnum } from '@systemeio/types'
import { units } from '@systemeio/util'
import { ChartOptions } from 'chart.js'
import { barChartOptions, withTooltipTitles } from 'shared/components/chart/chart-config'
import { currencyFormat } from 'shared/utils/currency-format'
import { getCssRgbValue } from 'shared/utils/get-css-rgb-value'

interface AffiliateChartOptionsParams {
  /* Currencies in dataset order, so a hovered bar is formatted in the currency it belongs to. */
  currencies: CurrencyEnum[]
  locale?: LocaleEnum
  selectedCurrency?: CurrencyEnum
  tooltipTitles?: string[]
}

export const getAffiliateChartOptions = ({
  currencies,
  locale,
  selectedCurrency,
  tooltipTitles = [],
}: AffiliateChartOptionsParams): ChartOptions<'bar'> => {
  const options = withTooltipTitles<'bar'>(barChartOptions, tooltipTitles)

  return {
    ...options,
    plugins: {
      ...options.plugins,
      /*
       * The only dashboard chart with several datasets, so it keeps the legend the others hide: it
       * names each currency and lets one be clicked out of the chart.
       */
      legend: {
        display: true,
        labels: {
          color: getCssRgbValue('--color-text-secondary'),
          usePointStyle: true,
          pointStyle: 'circle',
          boxWidth: 8,
          boxHeight: 8,
          padding: 16,
        },
      },
      tooltip: {
        ...options.plugins?.tooltip,
        callbacks: {
          ...options.plugins?.tooltip?.callbacks,
          label: ({ datasetIndex, parsed }) => {
            if (parsed.y === null) return ''

            const currency = currencies[datasetIndex]

            return currency
              ? currencyFormat(units(parsed.y), currency, locale, true)
              : String(parsed.y)
          },
        },
      },
    },
    scales: {
      ...options.scales,
      y: {
        ...options.scales?.y,
        ticks: {
          ...options.scales?.y?.ticks,
          callback: function (value) {
            if (!selectedCurrency) return value
            return currencyFormat(units(value), selectedCurrency, locale, true)
          },
        },
      },
    },
  }
}
